import html from '../Skills/html.png';
import css from '../Skills/css.png';
import js from '../Skills/js.png';
import reactjs from '../Skills/reactjs.png';
import nextjs from '../Skills/nextjs.png';
import nodejs from '../Skills/nodejs.png';
import expressjs from '../Skills/expressjs.png';
import mongodb from '../Skills/mongodb.png';
import ts from '../Skills/ts.png';
import gsap from '../Skills/gsap.png';
import threejs from '../Skills/threejs.png';
import tailwindcss from '../Skills/tailwindcss.png';
import styledcomponents from '../Skills/styledcomponents.png';
import cpp from '../Skills/cpp.png';
import python from '../Skills/python.png';

export const SkillsData = [
  {
    name: 'HTML5',
    img: html,
    color: '#ffffff'
  },
  {
    name: 'CSS3',
    img: css,
    color: '#ffffff'
  },
  {
    name: 'JAVASCRIPT',
    img: js,
    color: '#ffffff'
  },
  {
    name: 'REACT.JS',
    img: reactjs,
    color: '#ffffff'
  },
  {
    name: 'THREE.JS',
    img: threejs,
    color: '#ffffff'
  },
  {
    name: 'NEXT.JS',
    img: nextjs,
    color: '#ffffff'
  },
  {
    name: 'NODE.JS',
    img: nodejs,
    color: '#ffffff'
  },
  {
    name: 'EXPRESS.JS',
    img: expressjs,
    color: '#ffffff'
  },

  {
    name: 'MONGODB',
    img: mongodb,
    color: '#ffffff'
  },
  {
    name: 'GSAP',
    img: gsap,
    color: '#ffffff'
  },
  {
    name: 'TYPESCRIPT',
    img: ts,
    color: '#ffffff'
  },

  {
    name: 'TAILWIND-CSS',
    img: tailwindcss,
    color: '#ffffff'
  },
  {
    name: 'STYLED COMPONENTS',
    img: styledcomponents,
    color: '#ffffff'
  },
  {
    name: 'PYTHON',
    img: python,
    color: '#ffffff'
  },
  {
    name: 'C++',
    img: cpp,
    color: '#ffffff'
  }
];
